import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Apps, StoreApps } from 'src/app/models/apps';
import { NuvemshopAccountVM } from 'src/app/models/nuvemshop-account-vm';

@Component({
  selector: 'app-nuvemshop',
  templateUrl: './nuvemshop.component.html',
  styleUrls: ['./nuvemshop.component.scss']
})
export class NuvemshopComponent {
  @Input() visible: boolean = false;
  @Input() connected: boolean = false;
  @Input() selectedStoreApp: StoreApps | null = null;
  @Input() selectedProduct: Apps | null = null;
  @Input() loadingBtn: boolean = false;
  @Input() loading: boolean = false;
  @Input() nuvemshopAccounts: NuvemshopAccountVM[] = [];
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() connect = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();
  @Output() disconnect = new EventEmitter<void>();

  isMobile = false;

  ngOnInit() {
    this.isMobile = window.innerWidth <= 768;
  }

  onClose() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.close.emit();
  }

  trackByAccount = (_: number, account: NuvemshopAccountVM) => account.uid;

  getShopUrl(account?: NuvemshopAccountVM): string {
    console.log('getShopUrl')
    console.log(account)
    const domain = account?.domain ||
      this.selectedStoreApp?.form_value?.domain ||
      (this.selectedStoreApp as any)?.domain;
    if (!domain) {
      return '';
    }
    const trimmed = domain.trim();
    if (/^https?:\/\//i.test(trimmed)) {
      return trimmed;
    }
    return `https://${trimmed}`;
  }

  getStoreName(account?: NuvemshopAccountVM): string {
    return account?.store_name || account?.domain || this.selectedStoreApp?.form_value?.domain || 'Minha loja';
  }
}
